<div class="table-container" #tableContainer>
  <ng-container *ngIf="!config.paginator; else WITH_PAGINATOR">
    <p-table [ngClass]="config.className || 'eccc'"
             [value]="data"
             [resizableColumns]="true"
             [scrollable]="true"
             scrollHeight="100%"
             #dT>
      <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of config.columns"
             [ngStyle]="{ width: col.width ? col.width : 'auto', maxWidth: col.maxWidth ? col.maxWidth : 'inherited'}">
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th title="{{ config.translationPrefix + '.' + col.header | translate }}" pResizableColumn *ngFor="let col of config.columns; let i = index" [pSortableColumn]="col.sortField">
          <ng-container *ngIf="config.translationPrefix; else NO_TRANSLATION">
            <span>{{ config.translationPrefix + '.' + col.header | translate }}</span>
          </ng-container>
          <ng-template #NO_TRANSLATION>
            <span>col.header</span>
          </ng-template>
          <p-sortIcon id="{{col.field}}" [field]="col.field" *ngIf="col.sortField"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="tableColumns" let-rowIndex="rowIndex">
      <tr #rE>
        <td *ngFor="let col of config.columns; let i = index" pEditableColumn>
          <ng-container *ngIf="!col.templateRef; else CUSTOM_CONTENT">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="rowData[col.field]">
              </ng-template>
              <ng-template pTemplate="output">
                {{ rowData[col.field] }}
              </ng-template>
            </p-cellEditor>
          </ng-container>
          <ng-template #CUSTOM_CONTENT>
            <ng-container *ngTemplateOutlet="col.templateRef; context: {$implicit: rowData}"></ng-container>
          </ng-template>
        </td>
    </ng-template>
    </p-table>
  </ng-container>

  <ng-template #WITH_PAGINATOR>
    <p-table [ngClass]="config.className || 'eccc'"
             [class.pagebale]="config.paginator"
             (onLazyLoad)="onPaginationChanged($event)"
             [lazy]="true"
             [paginator]="true"
             [value]="data?.content"
             [totalRecords]="data?.totalElements"
             [rowsPerPageOptions]="itemsPerPage"
             [rows]="data?.size"
             [first]="firstItemIndex"
             [scrollable]="true"
             scrollHeight="465px"
             #dT>
      <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of config.columns"
             [ngStyle]="{ width: col.width ? col.width : 'auto', maxWidth: col.maxWidth ? col.maxWidth : 'inherited'}">
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th title="{{ config.translationPrefix + '.' + col.header | translate }}"  pResizableColumn *ngFor="let col of config.columns; let i = index" [pSortableColumn]="col.sortField">
          <ng-container *ngIf="config.translationPrefix; else NO_TRANSLATION">
            <span>{{ config.translationPrefix + '.' + col.header | translate }}</span>
          </ng-container>
          <ng-template #NO_TRANSLATION>
            <span>{{col.header}}</span>
          </ng-template>
          <p-sortIcon id="{{col.field}}" [field]="col.field" *ngIf="col.sortField"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="tableColumns" let-rowIndex="rowIndex">
      <tr #rE>
        <ng-container *ngFor="let col of config.columns; let i = index">
          <td role="button" aria-label="Edit" (click)="onRowEditInit(rowData)" *ngIf="!col.templateRef && col.editable" pEditableColumn>
            <ng-container>
              <ng-container *ngIf="col.translate; else DO_NOT_TRANSLATE">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="text" [(ngModel)]="rowData[col.field]">
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ (col.translationPrefix || config.translationPrefix) + '.' + rowData[col.field] | translate }}
                  </ng-template>
                </p-cellEditor>
              </ng-container>
              <ng-template #DO_NOT_TRANSLATE>
                <p-cellEditor>
                  <ng-container *ngIf="!col.dateTime && col.field !== 'account'&& col.field !== 'obligationId'  && col.field !== 'regularRate' && col.field !== 'increasedRateMultiplier'">
                    <ng-template pTemplate="input">
                      <input class="form-control" pInputText  type="text" [(ngModel)]="rowData[col.field]" required>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <span>
                        {{ rowData[col.field] }}
                      </span>
                    </ng-template>
                  </ng-container>
                  
                  <ng-container *ngIf="col.dateTime">
                    <ng-template pTemplate="input">
                      <p-datepicker appendTo="body" [ngModel]="rowData[col.field] | date: 'dd MMMM yyyy'" (ngModelChange)="rowData[col.field] = $event" dateFormat="dd MM yy" ></p-datepicker>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ rowData[col.field] | date: 'dd MMMM yyyy'}}
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="col.field === 'account'">
                    <ng-template pTemplate="input">
                      <input class="form-control" pInputText type="text" [(ngModel)]="rowData[col.field]['certificateNumber']" required>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ rowData[col.field]['certificateNumber']}}
                    </ng-template>
                  </ng-container>
                   <ng-container *ngIf="col.field === 'obligationId'">
                    <ng-template pTemplate="input">
                      <input class="form-control" pInputText type="text" [(ngModel)]="rowData[col.field]['obligationId']" required>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ rowData[col.field]['obligationId']}}
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="col.field === 'regularRate'">
                    <ng-template pTemplate="input">
                      <input class="form-control" pInputText type="text" [(ngModel)]="rowData[col.field]" required>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ rowData[col.field] | currency}}
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="col.field === 'increasedRateMultiplier'">
                    <ng-template pTemplate="input">
                      <input class="form-control" pInputText type="text" [(ngModel)]="rowData[col.field]" required>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ rowData[col.field] }}x
                    </ng-template>
                  </ng-container>
                </p-cellEditor>
              </ng-template>
            </ng-container>
          </td>
          <td *ngIf="!col.editable && col.templateRef">
            <ng-container *ngTemplateOutlet="col.templateRef; context: {$implicit: rowData}"></ng-container>
          </td>
          <td *ngIf="!col.editable && !col.templateRef">
            <ng-container *ngIf="col.dateTime">
              {{ rowData[col.field] | date: 'dd MMMM yyyy'}}
            </ng-container>
            <ng-container *ngIf="!col.dateTime">
              {{ rowData[col.field] }}
            </ng-container>
          </td>
          <td role="button" aria-label="Edit" (click)="onRowEditInit(rowData)" *ngIf="col.editable && col.templateRef" pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <ng-container *ngTemplateOutlet="col.templateRef; context: {$implicit: rowData}"></ng-container>
              </ng-template>
              <ng-template pTemplate="output">
                {{ rowData[col.field] }}
              </ng-template>
            </p-cellEditor>
          </td>
        </ng-container>
    </ng-template>

    <!-- <ng-template pTemplate="paginatorleft" let-state>
      <span class="paginator-left"
            [translate]="'COMMON.table.recordsDisplayedText'"
            [translateParams]="{
              from: state.first + 1,
              to: state.first + state.rows <=  state.totalRecords ? state.first + state.rows : state.totalRecords,
              total: state.totalRecords
            }">
      </span>
      <span class="pages-info"
            [translate]="'COMMON.table.currentPageText'"
            [translateParams]="{
              current: state.page + 1,
              total: data?.totalPages
            }">
      </span>
    </ng-template> -->

    </p-table>
  </ng-template>


</div>

<ng-template #TABLE_CONTENT>

</ng-template>
